var products_on_page = $('.products-on-page');
var next_url = products_on_page.data('next-url');

var load_more_btn = $('.load-more___btn');
var load_more_spinner = $('.load-more___spinner');

function loadMoreProducts () {

$.ajax (
    {
        url: next_url,
        type:'GET',
        dataType:'html',
        beforeSend: function() {
          load_more_btn.hide();
          load_more_spinner.show();
        }
    }
).done(function(next_page) {

    load_more_spinner.hide();
    
    var new_products = $(next_page).find('.products-on-page');
    var new_url = new_products.data('next-url');

    if(new_url) {
      load_more_btn.show();
    }
  
    next_url = new_url;
    
    products_on_page.append(new_products.html());
} )
  
}

function loadGridList () {

    // FOR GRID/LIST
    var load_product_type = $('#product-grid');
    var load_product_click = $('.icon-gl');

    load_product_type.toggleClass('listView');
    load_product_click.toggleClass('active');
}